import { render, staticRenderFns } from "./DeliveryRelated.vue?vue&type=template&id=18603710&"
import script from "./DeliveryRelated.vue?vue&type=script&lang=js&"
export * from "./DeliveryRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports